import { Right } from 'shared/src/userRole/UserRole.types';

export const NotAllowed: React.FC<{ neccessaryRight: Right }> = ({ neccessaryRight }) => {
  return <div>You dont have the right to to the Action! {neccessaryRight}</div>;
};
